import { Component, OnInit, Output, EventEmitter, OnDestroy, ViewChild, ElementRef, Input } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SharedDataService } from '../../../shared/services/shared-data.service';
import { Subscription } from 'rxjs';
import { singleUnit } from '../../../shared-html-components/details/packages';
import { TranslateService } from '@ngx-translate/core';
import { CalculationAssistant } from 'app/shared/utilities/calculationAssist';
import * as api from '../../../shared/api/apihandler';

@Component({
  selector: 'app-import-unit',
  templateUrl: './import-unit.component.html',
  styleUrls: ['./import-unit.component.css']
})
export class ImportUnitComponent implements OnInit, OnDestroy {
  companyInformationSubscription: Subscription;

  @ViewChild('ClosePackageImporterModal') modalCloser: ElementRef;
  @Output() unit = new EventEmitter();
  @Input() groups;
  @Input() selectedGroup: string;
  @Output() selectedGroupChange = new EventEmitter();

  manage = new UnitExportManager();
  ass = new CalculationAssistant();
  asMiscLine: boolean = false;
  asGroup:boolean = false;
  description = 'toDescription';

  constructor(private httpClient: HttpClient, private sharedData: SharedDataService, translate: TranslateService) {

}

  ngOnInit() {
    this.companyInformationSubscription = this.sharedData.companyInformation().subscribe(data => {
      this.manage.logo = data != null ? data.logo : null;
      this.manage.lingo = data != null ? data.companyLanguage : null;
      this.manage.companyId = !!data ? data.id : null;
    })
  }

  ngOnDestroy() {
    this.companyInformationSubscription.unsubscribe()
  }

  resetImport(){
    this.manage.searchString = '';
    this.manage.packageId = null;
    this.manage.packageType = 'own';
    this.manage.group = null;
    this.asMiscLine = false;
    this.getCompanyPackages();
    
  }

  getCompanyPackages() {
    if (this.manage.allData == null) {
      const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
      this.httpClient.get<any>(api.jubloApi + 'api/Website/CompanyPackages', { headers }).subscribe({
        next: (data) => {
          this.manage.allData = data;
          let a = document.getElementById('importPackageOwnPackagesSearch') as HTMLInputElement;
          a.focus();
        },
        error: err => console.error(err),
        complete: () => this.manage.search()
      });
    }
  }

  getPackage(id){
    this.manage.packageId = id;
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.httpClient.get(api.jubloApi + 'api/Website/Package/' + id, { headers }).subscribe(
      (data)=>{this.manage.package = data;}
    )
  }

  importPackage(){
    this.unit.emit({ isLibrary: false, unit: this.manage.package, asMiscLine: this.asMiscLine, asGroup: this.asGroup, group:this.manage.group, descriptionAs:this.description })
  }

  importPackageToOffer(id: string, isLibrary: boolean) {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.httpClient.get(api.jubloApi + 'api/Website/Package/' + id, { headers }).subscribe((data: singleUnit) => {
      this.unit.emit({ isLibrary: isLibrary, unit: data, asMiscLine: this.asMiscLine })
    },
      (response) => { console.log('Package importation error', response) },
      () => {
        // close modal if modal not closed
        this.manage.packageType = null;
        this.manage.searchString = '';
        this.modalCloser.nativeElement.click();
      }
    )
  }

  priceFormatter(price) {
    return price != null ? new Intl.NumberFormat(this.manage.lingo != null ? this.manage.lingo : 'da-DK', {
      style: 'currency',
      currency: 'DKK',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,

    }).format(price) : '';
  }
}

export class UnitExportManager {
  packageType: 'own' | 'library' = 'own';
  allData;
  data;
  logo;
  group;
  companyId;
  lingo;
  searchString: string = '';
  packageId: string;
  package;
  search() {
    var s = this.searchString.toLowerCase();
    if (!!s) {
      this.data = this.allData.filter(x => 
        !!x.name && x.name.toLowerCase().match(s) || 
        !!x.packageNumber && x.packageNumber.toLowerCase().match(s) || 
        !!x.category && x.category.toLowerCase().match(s) || 
        !!x.skill && x.skill.toLowerCase().match(s)
        )
    }
    else { this.data = this.allData }
  }

  addGroup(){
    document.getElementById('productGridGroupAdder').click()
  }
}
